import { SidebarSectionType } from 'data/types';

function findFirstIncompleteConfigStep(
  sections: SidebarSectionType[],
  hasUnzonedSpaces: boolean
): SidebarSectionType | undefined {
  const firstIncomplete = sections.find((step) => !step.requirementsMet);
  const condensersComplete =
    sections.find((section) => section.id === 'condensers')?.requirementsMet ===
    true;

  if (
    hasUnzonedSpaces &&
    condensersComplete &&
    firstIncomplete &&
    !firstIncomplete.id.startsWith('add_spaces_zone_')
  ) {
    return (
      [...sections]
        .reverse()
        .find((step) => step.id.startsWith('add_spaces_zone_')) ??
      firstIncomplete
    );
  }

  return firstIncomplete;
}

export function resolveConfigurationEntryStepId(
  sections: SidebarSectionType[],
  hasUnzonedSpaces: boolean
): string {
  return (
    findFirstIncompleteConfigStep(sections, hasUnzonedSpaces)?.id ??
    sections[0]?.id ??
    'condensers'
  );
}
